import { handleRequest, handleUploadRequest } from '../services/APIService';

export const FETCH_APPOINTMENT_REQUESTS = 'FETCH_APPOINTMENT_REQUESTS';
export const FETCH_APPOINTMENT_REQUESTS_ERROR =
  'FETCH_APPOINTMENT_REQUESTS_ERROR';
export const RESET_APPOINTMENT_REQUESTS = 'RESET_APPOINTMENT_REQUESTS';
export const SET_STATUS_TOGGLE_STATE = 'SET_STATUS_TOGGLE_STATE';

export const CREATE_APPOINTMENT_REQUEST_MESSAGE =
  'CREATE_APPOINTMENT_REQUEST_MESSAGE';
export const CREATE_APPOINTMENT_REQUEST_MESSAGE_ERROR =
  'CREATE_APPOINTMENT_REQUEST_MESSAGE_ERROR';

export const UPLOAD_APPOINTMENT_REQUEST_ATTACHMENT =
  'UPLOAD_APPOINTMENT_REQUEST_ATTACHMENT';
export const UPLOAD_APPOINTMENT_REQUEST_ATTACHMENT_ERROR =
  'UPLOAD_APPOINTMENT_REQUEST_ATTACHMENT_ERROR';

export const getAllAppointmentRequests = (params) => {
  return async (dispatch) => {
    try {
      const results = await handleRequest(
        'get',
        `appointment-requests`,
        true,
        {},
        params,
      );

      dispatch({
        type: FETCH_APPOINTMENT_REQUESTS,
        payload: results.data,
      });
    } catch (error) {
      dispatch({
        type: FETCH_APPOINTMENT_REQUESTS_ERROR,
        payload: error.response || error,
      });
    }
  };
};

export const resetAppointmentRequests = () => ({
  type: RESET_APPOINTMENT_REQUESTS,
});

export const setStatusToggleState = (pageType, status) => ({
  type: SET_STATUS_TOGGLE_STATE,
  payload: { pageType, status },
});

export const createAppointmentRequestMessage = ({
  appointmentRequestId,
  message,
  requiresResponse = false,
  attachments = { images: [], pdfs: [] },
}) => {
  return async (dispatch) => {
    try {
      const results = await handleRequest(
        'post',
        `appointment-requests/${appointmentRequestId}/messages`,
        true,
        {
          message,
          requiresResponse,
          attachments,
        },
      );

      return dispatch({
        type: CREATE_APPOINTMENT_REQUEST_MESSAGE,
        payload: results.data,
      });
    } catch (error) {
      return dispatch({
        type: CREATE_APPOINTMENT_REQUEST_MESSAGE_ERROR,
        payload: error.response || error,
      });
    }
  };
};

export const uploadAppointmentRequestAttachment = (file, type) => {
  return async (dispatch) => {
    try {
      const results = await handleUploadRequest(
        file,
        `appointment-requests/${type}`,
      );
      return dispatch({
        type: UPLOAD_APPOINTMENT_REQUEST_ATTACHMENT,
        payload: { ...results.data, type },
      });
    } catch (error) {
      return dispatch({
        type: UPLOAD_APPOINTMENT_REQUEST_ATTACHMENT_ERROR,
        payload: error,
      });
    }
  };
};
